import {setEnv as _setEnv} from '@/components';

export function setEnv(env) {
  // if (env === 'PROD') {
  //   _setEnv('PROD', { primaryColor: '#1890ff' });
  // } else {
  _setEnv(env);
  // }

  if (env !== 'PROD') document.title = `CCMS Front [${env}]`;
  else document.title = 'CCMS Front';
}

if (['LOCAL', 'DEV'].includes(import.meta.env.VITE_APP_ENV)) {
  window.setEnv = setEnv;
}
